import { useStage } from './useStage'

export default () => useStage('national-id-card')
